/* global MyForm, Loc, MyFacture, MyWindow, Qtip, MyTabs, Utils, NumberFormat, Big, Listing, DocFormv2, Persistent, Purchases, Agenda, booksListing */

window.itemPrez = {
	
	startDemo: function(){
		
		var options = {
			type  : '',
			width : 940,
			title : "Présentation de la nouvelle fiche produit !",
			buttons : [
			{
					text : Loc.g("Fermer"), 
					click : function(){
						$(this).dialog("close");
						$('#youtubeIframe').remove();
					}
				}
			]

		};
		MyWindow.alert('<iframe id="youtubeIframe" width="900" height="600" src="//www.youtube.com/embed/LmaJcwpdZgU" frameborder="0" allowfullscreen=""><xsl:comment /></iframe>', options);
	}
	
};

window.ItemThreshold = {
	
	addOnVariations : function(){
		MyWindow.alert(Loc.g("Pour gérer vos seuils, rendez vous sur une fiche déclinaison") + '.', { type : 'warning' });
	},
	
	loadForm : function(id, declid){
		
		id		= undefined == id	? "" : id;
		declid	= undefined == declid || "" == declid ? "0"	: declid;
		
		var title	= Loc.g('Seuil(s) de commande');
		var formID	= 'itemThresholdForm';
		
		var options = {
			
			title	: title,
			width	: 640,
			buttons	: [
				{
					text	: Loc.g("Annuler"),
					click	: function(){
						$(this).dialog("close");
					}
				},
				{
					
					text	: Loc.g("Enregistrer"),
					class	: 'btn btn-primary',
					click	: function(){
						$('#' + formID).submit();
					}
					
				}
			],
			callback : function(){

				var $form = $('#' + formID);
				
				$('input[type="checkbox"]', $form).change(function(){
					
					var $checkbox		= $(this);
					var $row			= $checkbox.closest('tr');
					var $inputTarget	= $('input#thresholds_' + $checkbox.data('linkedtype') + '_' + $checkbox.data('linkedid') + '_' + $checkbox.data('type'), $row);
					
					$inputTarget.prop('readonly', !$checkbox.is(':checked'));
					
				});

				MyForm.prepare(formID, "catalogueThreshold&action=record", {
					
					// Options
					dataType : 'json',
					
					// Callbacks
					success : function(response){
						
						if(MyForm.processJson(response, formID)){
							
							MyWindow.close();
							MyWindow.alert(Loc.g("Vos seuils de commande ont été enregistrés") + '.', {type : 'confirm'});
							
						}
						
					}
					
				});

				MyFacture.customForm('#'+formID);
				
			}

		};
		
		MyWindow.load("catalogueThreshold", { action : "loadForm", itemid : id, declid : declid }, options);
		
	}
	
};

window.Catalogue = {
	
	context		: '',
	onlyjson	: '',
	massOptions : null,
    
	loadCatalogue: function(context, onlyjson, afterOptions, fromPurchase){
		
		fromPurchase = undefined === fromPurchase ? '' : fromPurchase;

		var options = {
			title	: Loc.g("Catalogue de produits et services"),
			buttons	: [
				{
					text : Loc.g("Annuler"),
					'class' : 'btn-default',
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Valider"), 
					click : function(){
						$("#docCatalogueForm").submit();
					}
				}
			],
			width		: 1200,
			height		: 650,
			dialogClass : "ui-dialog-nopadding",
			callback	: function(){
				Catalogue.prepareCatalogueForm();
			}
		};
		
		Catalogue.context = context;
		Catalogue.beforeOrAfter = afterOptions;
		Catalogue.onlyjson = onlyjson === undefined ? 'N' : onlyjson;
		
		data = {};
		data.action		= 'catalogueForm';
		data.context	= context;
		data.contextDoc = fromPurchase ? 'purchase' : 'sale';
		
		if(Catalogue.context === 'doc'){
			data = $.extend(data, DocFormv2.getNumFormat(true));
		}
		
		MyWindow.load("catalogue", data, options);
	},
	
	prepareCatalogueForm: function(){
		
		var useEcotaxe	= $("#useEcotaxe").val();
		var lang		= $("#docLang").val();
		
		var formId	= "docCatalogueForm";
		var options = {
			success:function(data){
				Catalogue.recordCatalogueCallback(data, 'docCatalogueForm');
			}, 
			dataType:"json"
		};
		var data	= {
			action		: 'recordCatalogue', 
			startnum	: Persistent.get("rowscounter"), 
			onlyjson	: Catalogue.onlyjson, 
			thirdid		: $("#thirdid").val(), 
			useEcotaxe	: useEcotaxe, 
			doclang		: lang
		};
		data = $.extend(true, data, DocFormv2.getNumFormat(true));
		data.context = Catalogue.context;
		
		MyForm.prepare(formId, "catalogue&"+$.param(data), options, true);
		Catalogue.loadCatalogueTab(undefined, undefined);
	},
	
	loadCatalogueTab: function(tab, data){
		
		tab = undefined === tab ? '' : tab;
		data = undefined === data ? {} : data;
		
		if (Catalogue.context === 'doc'){
			data = $.extend(true, data, DocFormv2.getProperties(['docid', 'doctype', 'rateCategory', 'isTaxesInc']));
			data = $.extend(true, data, {thirdid : $("#thirdid").val()});
		}
		
		var selector	= $('#catalogue_popup_filter_tags');
		var parent		= selector.parent();
		if(parent.find('#token-input-catalogue_popup_filter_tags').length) {
			selector.tokenInput('clear');
		}
		
		data = $.extend(true, data, {action:"catalogueTab", tab:tab, context : Catalogue.context, thirdid: $("#thirdid").val()});
		$('#catalogLoader').show();
		MyFacture.post("catalogue", data, function(data){Catalogue.loadCatalogueTabCallback(data);}, "json");MyFacture.initEvent();
		
	},

	loadCatalogueTabCallback: function(data){

		$("#popupwindow .catalogueTabs li").removeClass('active');
		$("#popupwindow .catalogueTabs #tab_"+data.tab).addClass('active');

		if (data.tab === "items" || data.tab === "services" ) {
			$('.catalogSearch').show();
			$('.catalogSearch #catalogue_popup_filter_name').unbind('keypress').bind('keypress', function(e){
				if (e.keyCode === 13) {
					Catalogue.filterCatalogue(data);
				}
			});
        } else {
            $('.catalogSearch').hide();
        }
		
		$('#catalogLoader').hide();
        $("#currentTab").val(data.tab);
        $("#docCatalogueFormContent").html(data.content);
		
		if (data.tab !== "items" && data.tab !== "services"){
			catalogueItem.prepareAndComputeEcoTax(NumberFormat.loadFromInputs("numformat_"));
		}
		
        MyFacture.customForm($("#docCatalogueFormContent"));
      
       $('#pickedFromCatalogue tr').each(function(){
            var id = $(this).attr("id");
			if(id !== undefined){
				var parts = id.split('-');
				$("#docCatalogueFormContent #row_"+parts[1]+"_"+parts[2]).addClass('lineIntoCart');
			}
        });
		
		Catalogue.initDocItemListQtips();
		
	   // REBIND SUBMIT EVENT FOR RIGHT FORM
	   
		var useEcotaxe	= $("#useEcotaxe").val();
		var lang		= $("#docLang").val();
	   
		var formId = "pickedFromCatalogue";
		var options = {success:function(data){Catalogue.recordCatalogueCallback(data, formId);}, dataType:"json"};
		var dataForm = {context:Catalogue.context, onlyjson:Catalogue.onlyjson, action: 'recordCatalogue', currentTab : data.tab, startnum: Persistent.get("rowscounter"), thirdid: $("#thirdid").val(), useEcotaxe:useEcotaxe, doclang:lang};
		
		if (Catalogue.context === 'doc'){
			dataForm = $.extend(true, dataForm, DocFormv2.getProperties(['docid', 'doctype', 'rateCategory']));
			dataForm = $.extend(true, dataForm, DocFormv2.getNumFormat(true));
			dataForm.ecoTaxId = DocFormv2.ecoTax.id;
			dataForm.hasDoubleVat = DocFormv2.doubleVat;
		}
		MyForm.prepare(formId, "catalogue&"+$.param(dataForm), options, true);
		
		var btnOpt = [];
		var validBtn = {
			text	: Loc.g('Valider'),
			'class'	: 'btn-primary'
		};
		var cancelBtn = {
			text	: Loc.g('Annuler'), 
			'class' : 'btn-default',
			click	: function(){
				$(this).dialog("close");
			}
		};

		switch(data.tab){
			case 'items' :  // SUBMIT CART WHEN ITEM OR SERVICE TAB
			case 'services' :
				validBtn.click = function(){$("#pickedFromCatalogue").submit();};
				break;
				
			default: // SUBMIT CREATION FORM IN CASE OF ITEM OR SERVICE FORM
			   validBtn.click = function(){$("#docCatalogueForm").submit();};
				if (Catalogue.context === 'doc'){
					var docProps = DocFormv2.getProperties(['docid', 'doctype', 'rateCategory']);
					$("#docCatalogueForm").append('<input type="hidden" name="doctype"		value="'+docProps.doctype+'" />');
					$("#docCatalogueForm").append('<input type="hidden" name="docid"		value="'+docProps.docid+'" />');
					$("#docCatalogueForm").append('<input type="hidden" name="rateCategory" value="'+docProps.rateCategory+'" />');
				}
				
			break;
		}
		catalogueItem.adjustFieldset();
		btnOpt.push(cancelBtn);
		btnOpt.push(validBtn);
		MyWindow.addOption('buttons', btnOpt);
		Qtip.init();
		
	},
	
	editProduct: function(tab, prodid){
		Catalogue.hideQtip();
		Catalogue.loadCatalogueTab(tab, {id:prodid});
	},
	
	hideQtip : function(){
		$(".qtip").each(function() {
			$(this).css('display','none');
		});
		
	},
	
	changeCataloguePage: function(page){

        if("next" === page){
			page = $("#currentPage").val()*1+1;
		}
		if("prev" === page){
			page = $("#currentPage").val()*1-1;
		}

		$("#currentPage").val(parseInt(page));

        var data = {
			action:					"catalogueTab",
			tab: 					$("#currentTab").val(),
			p: 						page,
			search_name: 			$("#catalogue_popup_filter_name").val(),
			search_tags: 			$("#catalogue_popup_filter_tags").val(),
			search_tagsMode: 		$(".catalogSearch input[name=catalogue_popup_filter_tagsMode]:checked").val(),
			search_categoryid : 	$(".catalogSearch select[name=catalogue_popup_filter_categoryid]").val(),
			search_containsMode:	$('#catalogue_popup_filter_containsMode').val(),
			doctype : 				$("#doctype").val(),
			rateCategory :			$('#rateCategory').val(),
			thirdid : 				$("#thirdid").val()
        };
		
		if (Catalogue.context === 'doc'){
			data = $.extend(true, data, DocFormv2.getProperties(['docid', 'doctype', 'rateCategory']));
		}
		
		data.context = Catalogue.context;
		
		if ($('#catalogLoader').length > 0){
			$('#catalogLoader').show();
		}
		
		MyFacture.post("catalogue", data, function(data){Catalogue.loadCatalogueTabCallback(data);}, "json");
		
	},

    filterCatalogue: function() {

		if ($('#catalogLoader').length > 0){
			$('#catalogLoader').show();
		}

        var data = {
			action				: "catalogueTab",
			tab					: $("#currentTab").val(),
			p					: 1,
			doctype				: $("#doctype").val(),
			search_name			: $("#catalogue_popup_filter_name").val(),
			search_containsMode	: $("#catalogue_popup_filter_containsMode").val(),
			search_tags			: $("#catalogue_popup_filter_tags").val(),
			search_tagsMode		: $(".catalogSearch input[name=catalogue_popup_filter_tagsMode]:checked").val(),
			search_categoryid	: $(".catalogSearch select[name=catalogue_popup_filter_categoryid]").val(),
			rateCategory		: $('#rateCategory').val(),
			thirdid				: $("#thirdid").val()
		};
		
		data.context = Catalogue.context;
        MyFacture.post("catalogue", data, function(data){Catalogue.loadCatalogueTabCallback(data);}, "json");
		Catalogue.initDocItemListQtips();
    },

    resetFilterCatalogue: function(reload){
		
		if ($('#catalogLoader').length > 0){
			$('#catalogLoader').show();
		}
        
		$("#catalogue_popup_filter_categoryid").val('');
		
		$("#catalogue_popup_filter_name").val('');
        $("#catalogue_popup_filter_tags").tokenInput("clear");
		
		if (reload === 'Y'){
			$('#catalogButtonSearch').trigger('click');
		}
		
    },
	
	addItemToCart: function (itemid, decliId, type){
		
		var row			= $('#row_'+itemid+'_'+decliId);
		var rowDesc		= $('#row_'+itemid+'_'+decliId+'_desc');
		var itemName	= row.find('.row_item_name').html();
		
		$('#cart .cart-placeholder').hide();
		
		if ($('#cartLine-'+itemid+"-"+decliId).length === 0){
			
			var orderTmp		= $('.cartContainer tr.cartLineTpl input.cart_order');
			var orderTmpValue	= parseInt(orderTmp.attr('value'));
			orderTmp.attr('value', orderTmpValue + 1);
			
			var cartLine = $('#cart .cartLineTpl').clone();
			
			row.addClass('lineIntoCart');
			rowDesc.addClass('lineIntoCart-last');
			
			cartLine.removeClass("cartLineTpl hidden");
			
			cartLine.attr('class', 'cartLine enable cartLine-'+itemid);
			cartLine.attr('id', 'cartLine-'+itemid+"-"+decliId);
			
			cartLine.find('input.cart_id').attr("name", type+"s["+itemid+"-"+decliId+"][id]").attr('value', itemid);
			cartLine.find('input.cart_declid').attr("name", type+"s["+itemid+"-"+decliId+"][declid]").attr('value', decliId);
			cartLine.find('input.cart_order').attr("name", type+"s["+itemid+"-"+decliId+"][order]").attr('value', orderTmpValue);
			
			cartLine.find('label.item_name').html(itemName);
			cartLine.find('span.item_image').html(row.find('.row_item_image').html());
			
			cartLine.find('.btnDelete').attr('onclick', 'Catalogue.deleteCartLine('+itemid+','+decliId+')');
			$("#cart table").append(cartLine);
			
		}
		
	},
	
	deleteCartLine : function(lineid, decliId){
		
		$("#cartLine-"+lineid+"-"+decliId).fadeOut('fast', function(){
			$(this).remove();
			if ($(".cartLine-"+lineid+"-"+decliId).length === 0){
				$('#row_'+lineid+'_'+decliId).removeClass('lineIntoCart');
				$('#row_'+lineid+'_'+decliId+'_desc').removeClass('lineIntoCart-last');
			}
			if ($('#cart .cartLine').length === 0){
				$('#cart .cart-placeholconsole.logder').show();
			}
		});
		
	},
	
	recordCatalogueCallback: function(data, formId){
		
		formId = typeof(formId) === undefined ? "docCatalogueForm" : formId;
		
		var formIsOk = MyForm.processJson(data, formId);
		if(formIsOk){
			if(data.rows){
				switch(Catalogue.context){
					case 'doc' :		DocFormv2.recordCatalogueCallback(data, Catalogue.beforeOrAfter);break;
					case 'purchase' :	Purchases.catalogCallback(data);break;
				}
			}
			
			if(data.showDiscount){
				
				if($('#hideColumnDiscount').prop('checked')){
					$('#hideColumnDiscount').click();
				}
				if(!$('#discountByRows').prop('checked')){
					$('#discountByRows').click();
				}
			}
			
			Catalogue.onlyjson = '';
			Catalogue.context = '';
			MyWindow.close();
		}
	},
	
	prepareFilterForm: function(itmType){
		
        var options = {
			beforeSend : function(){},
			success:function(data){
				Catalogue.processFilterForm(data, itmType);
			}, 
			dataType:"json",
			data	: {
				action		: 'updateListing',
				item_type	: itmType.substring(0, itmType.length - 1)
			}
		};
		
        MyForm.prepare(itmType+"FilterForm", "catalogue", options);
        Qtip.init();
    },
	
	filterListingWithBc: function (bc){
		
		$('.filter_barcode_small').parent().find('.filter_underlabel').slideDown();
		$('.barcodeListingFilter').val(bc).trigger('keyup');
		
	},
	
	processFilterForm: function(data, itmType){
		Listing.refresh(itmType+"Listing", data, eval('data.'+itmType+'_metadatas'));	
		
	},
	
	buildPagenum: function(pagenum, nbpage){},
	
	listenDouchetteMode: function(selector, callback){

		/* INIT BARCODE */
        var keysToIgnore = [13, 16, 27, 32];
		var buffer = "";
		var timeOut = true;
		
		if ($('#docForm').length === 0){
			selector.unbind('keypress').bind('keypress', function(e){
				var keyCode = e.keyCode;
				if(keyCode === 13) {
					e.preventDefault();
					return false;
				}
			});
		}

		selector.unbind('keypress').bind('keypress', function(e){
			if ($(e.currentTarget.activeElement).is("body")){
				var keyCode = e.keyCode;

				if ($.inArray(keyCode, keysToIgnore) < 0){
					buffer += String.fromCharCode(e.keyCode);
					if (timeOut){
						setTimeout(function(){
							if (buffer.length >= 8){
								eval(callback+"('"+buffer+"')");
							}
							buffer = "";
							timeOut = true;
						}, 500);
					}

					timeOut = false;
				}
			}
			
		});
	},
	
	switchPosView : function(toSwitch, listingObject, rowSelection){
		
		MyWindow.load(
			'catalogue', 
			{
				action		: 'switchPosView',
				toSwitch	: toSwitch,
				items		: rowSelection
			},
			{
				title		: Loc.g('Affichage des produits / services dans la caisse'),
			},
			'json'
		);
	},
	
	editNewItemVat: function(listingObject, rowSelection){
	
		MyWindow.load('catalogue', 
			{
				action		: 'editNewItemVat',
				items		: rowSelection
			},
			{
				title		: Loc.g('Modifier les Taux de TVA du catalogue'),
				buttons		: [
					{
						text : Loc.g("Annuler"), 
						click : function(){
							MyWindow.close();
						}
					},
                    {
                        text : Loc.g("Enregistrer"), 
						click : function(){
                        $("#editNewItemVatForm").submit();
                    }
                    }
				],
				callback	: function(){Catalogue.prepareeditNewItemVatForm();}
			},
			
			'json'
		);
		
	},
	
	prepareeditNewItemVatForm: function(){

		var formId = "editNewItemVatForm";
		MyForm.prepare(formId, "catalogue&action=recordEditNewItemVatForm", {
			success:function(data){
				MyWindow.close();
				if (data.status === "ok"){
					MyWindow.alert(data.editNewItemVatResut, {type:'confirm'});
				} else {
					MyWindow.alert(Loc.g('Une erreur est survenue'), {type:'error'});
				}
			}, 
			dataType: "json"
		}, true);
		
	},

	initDocItemListQtips: function(){
		
		var lines = $('#docCatalogueFormContent .contentList tbody tr');
		
		$.each(lines, function(k,v){
			var me		= $(v);
			var content = Utils.nl2br(me.find('.row_item_notes').html());
			
			if (content !== ''){
				me.find('.row_item_name').qtip({
					style : {
						classes : 'custom-qtip',
						def		: false
					},
					position: {
						viewport: true,
					},
					show : {
						event : 'mouseover'
					},
					hide : {
						event: 'mouseout', 
						fixed: true,
						delay: 100
					},
					content:{
						text: content
					}
				});
			}
			
			
		});
			
	},
	
	switchTimetrackingEnabled: function(enable, listingObject, rowSelection){
	
		var title = Loc.g('Rendre les services utilisables dans le timetracking');
		
		if (enable == "N"){
			title = Loc.g('Ne plus rendre les services utilisables dans le timetracking');
		}
		
		MyWindow.load('catalogue', 
			{
				action		: 'switchTimetrackingEnabled',
				items		: rowSelection,
				enable		: enable
			},
			{
				title		: title,
				buttons		: [
					{
						text : Loc.g("Ok"), 
						click : function(){
							MyWindow.close();
						}
					}
				],
				close: function(){
					
					if ($('#itemsListing_container').length > 0){
						Listing.update('itemsListing', false);
					} else if ($('#servicesListing_container').length > 0){
						Listing.update('servicesListing', false);
					}else {								
						Utils.reload();;
					}
					
				}
			}, 'json'
		);
		
	},
	
	massEditTradeNameToNode: function (rowSelection, type){
		
		var title = Loc.g('Ajouter le nom commercial à la description');
		var button	= Loc.g("Ajouter à la description");
		
		if (type === 'delete'){
			title = Loc.g('Supprimer le nom commercial de la description');
			button = Loc.g('Supprimer de la description');
		}
		
		MyWindow.load('catalogue', 
			{
				action		: 'massEditTradeNameToNote',
				items		: rowSelection,
				type		: type
			},
			{
				title		: title,
				buttons		: [
					{
						text : Loc.g("Annuler"), 
						click : function(){
							MyWindow.close();
						}
					},
                    {
                        text : button, 
						click : function(){
                        $("#massEditTradeNameToNote").submit();
                    }
                    }
                ],
				callback	: function(){Catalogue.prepareMassTradeNameToNote();}
			},
			
			'json'
		);
		
	},
	
	prepareMassTradeNameToNote: function(){

		var formId = "massEditTradeNameToNote";
		MyForm.prepare(formId, "catalogue&action=recordmassEditTradeNameToNote", {
			success:function(data){
				MyWindow.close();
				if (data.status === "ok"){
					MyWindow.alert(Loc.g('Les modifications ont correctement été appliquées'), {type:'confirm'});
				} else {
					MyWindow.alert(Loc.g('Une erreur est survenue'), {type:'error'});
				}
			}, 
			dataType: "json"
		}, true);
		
	},

	updateState : function(rowSelection) {

		var options = {
			title	: Loc.g("Archiver / désarchiver"),
			buttons	: [
				{
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer"), 
					"class":"btn btn-primary", 
					click : function(){
						$("#updateStateForm").submit();
					}
				}
			],
			width:500,
			callback	: function(){

				var popup = $(this);
				var params = {
					action	: 'updateStateRecord', 
					items	: rowSelection
				};

				var options = {
					method: "POST",
					success:function(data){
						
						MyWindow.close();

						var msg = "";
						
						if(data.modified.length > 0) {
							
							var res = "<div class='table' style='margin-top: 6px;'><table>";
							for(var i in data.modified) {
								res+="<tr><td>"+data.modified[i]+"</td></tr>";
							}
							res += "</table></div>";
							msg = Loc.g("Les produits suivants ont été " + (data.state_activ === 'Y' ? 'désarchivés' : 'archivés')) + " : <br/>" + res;

						}else {
							msg = "<p class='alert alert-info'>"+Loc.g("Aucun élément n‘a été mis à jour.")+"</p>";
						}

						MyWindow.alert(
							msg, 
							{
								title : Loc.g('Archiver / désarchiver'), 
								type:'info',
								buttons	: [
									{text : Loc.g("Ok"), click : function(){
										$("#itemsFilterForm").submit();
										$(this).dialog("close");
										$("#groupedActionContainer").hide();
										Utils.reload();
									}}
								]
							}
						);
					}, 
					dataType:"json",
					data: params
				};
				

				MyForm.prepare("updateStateForm", "catalogue", options, true);
				MyFacture.customForm();

			}
		};
		
		MyWindow.load('catalogue', {action:"updateStateForm"}, options);
	},
	
	deleteItemGroupAction : function(rowSelection) {
		var msg =  Loc.g('Supprimer ces entrées du catalogue ?');
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression"),
			buttons		: [
				{	
					text	: Loc.g("Non"), 
					click	: function(){
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Oui"), 
					click	: function(){
						
						var datas = {action:"deleteItemGroupAction", rowSelection:rowSelection};
						
						MyFacture.post("catalogueitem", datas, function(data){
							if ($('#itemsListing_container').length > 0){
								Listing.update('itemsListing', false);
							} else if ($('#servicesListing_container').length > 0){
								Listing.update('servicesListing', false);
							}else {
								Utils.reload();
							}
						}, "json");
						$(this).dialog('close');
					}
				}
			]
		};

		MyWindow.alert(msg, options);
	}
	
};

window.catalogueItem = {
	
	add: function(create){
		
		$("#itemAgain").val(create ? "Y" : "N");
		$("#itemForm").submit();
		
	},

	buildTitle: function (type, id = null) {
		if(id !== null){
			switch (type){
				case "service":
					return Loc.g('Modifier un service');
				case "item":
				default:
					return Loc.g('Modifier un produit');
			}
		} else {
			switch (type){
				case "service":
					return Loc.g("Ajouter un service");
				case "item":
				default :
					return Loc.g('Ajouter un produit');
			}
		}
	},

	edit: function(type, id = null, asNew = false, title = ""){
		if (title === "") {
			title = this.buildTitle(type, id);
		}

		var options = {
			title	: title,
			width	: 1200,
			height	: 900,
			buttons	: [
                {
                    text : Loc.g("Annuler"),
                    click :  function(){$(this).dialog("close");}
                },
                {
                    text : Loc.g("Enregistrer et ajouter"),
					'class' : 'btn btn-primary',
                    click : function(){catalogueItem.add(true);}
                },
                {
					text : Loc.g("Enregistrer"),
					'data-bot': 'product-form--save',
					click : function(){catalogueItem.add();}
				}
			],
			callback	: function(){
				$('#item_name').focus();
				catalogueItem.prepareEditForm();
				catalogueItem.adjustFieldset();
				Qtip.init();
			}
		};

		MyWindow.load("catalogueitem", {action:"form", type:type, id:id, asNew:asNew}, options);
	},

	editDecli: function(type, id, decli) {
		var options = {
			title	: Loc.g('Modifier un produit'),
			width	: 1200,
			height	: 600,
			buttons	: [
				{
					text : Loc.g("Annuler"),
					click :  function(){$(this).dialog("close");}
				},
                {
                    text : Loc.g("Enregistrer"),
                    click : function(){$("#itemDecliForm").submit();}
                }
            ],
			callback	: function(){
				$('#item_name').focus();
				catalogueItem.prepareEditDecliForm();
				catalogueItem.adjustFieldset();
				Qtip.init();
			}
		};
		
		MyWindow.load("catalogueitem", {action:"formDecli", type:type, id:id, decli:decli}, options);
	},

	prepareEditForm: function(){
		var formId = 'itemForm';
		
		catalogueItem.prepareAndComputeEcoTax(NumberFormat.loadFromInputs("numformat_"));
		var options = {success:function(data){catalogueItem.recordCallback(data);}, dataType:"json"};
		MyForm.prepare(formId, "catalogueitem&action=record", options, true);
		MyFacture.initEvent("#"+formId);
		MyFacture.customForm("#"+formId);
		
	},
	
	prepareEditDecliForm: function() {
		var formId = 'itemDecliForm';
		
		var options = {success:function(data){catalogueItem.recordDecliCallback(data);}, dataType:"json"};
		MyForm.prepare(formId, "catalogueitem&action=recordDecli&type=item", options, true);
		MyFacture.initEvent("#"+formId);
		MyFacture.customForm("#"+formId);
	},

	recordCallback: function(data){
		
		var formIsOk = MyForm.processJson(data, "itemForm");
		
		if(!formIsOk){
			var alertDiv = $('#alertDiv');
			if(data.form.fields.length === 1 && data.form.fields[0].fieldId === "checkNameExist") {
				alertDiv.html(
					window.i18n.__(
						"Le produit '%(productName)s' existe déjà.",
						{'productName' : data.form.fields[0].value }
					)
					+ Loc.g('Veuillez changer votre référence.')
				);
				alertDiv.show();
			} else {
				alertDiv.hide();
				for(var i in data.form.fields){
					if(data.form.fields[i].fieldId === 'item_inPos'){
						var alertMsg = '<div class="alert alert-danger">'+data.form.fields[i].msg+'</div>';
						$('#'+data.form.fields[i].fieldId).closest('form').find('.alert').remove();
						$('#'+data.form.fields[i].fieldId).closest('form').prepend(alertMsg);
					}
				}
			}
			return false;
		}
		
		var itemAgain	= $("#itemAgain").val();
		var type		= $("#item_type").val();
		
		var listingName = "item"===type ? "itemsListing" : "servicesListing"; 
		var listingExist = $('#'+listingName+'_container').length > 0;

		const listingV2Exist = $('.listing-layout').length > 0
		
		MyWindow.close();
		
		
		if(itemAgain === "Y"){
			catalogueItem.edit(type);
			return true;
		} else {
				Utils.relocate("?_f=catalogueitem&id="+data.item.id+"&type="+data.item.type);
		}

		return true;
		
	},
	
	recordDecliCallback: function(data) {
		var formIsOk = MyForm.processJson(data, "itemDecliForm");
		
		if(formIsOk) {
			Utils.relocate("?_f=catalogueitem&id="+data.item.id+"&type="+data.item.type+"&declid="+data.item.decl);
		}
	},
	
	prepareAndComputeEcoTax: function(numFormat){
		var currentVal = new Big(0);
		
		currentVal = currentVal.plus(NumberFormat.formatToFloat($("#pricesInfos #item_ecoTax").val(),numFormat));
		$('#pricesInfos #item_ecoTaxTTC').val(NumberFormat.formatToDisplay(currentVal.times("1.2").round(parseInt(numFormat.precision, 10)), numFormat));
		
		$('#pricesInfos .ecoTaxToggler').click(function(){
			if ($('#pricesInfos .ecoTaxToggler').is(':checked')){
				$('#pricesInfos .usingEcoTax').show();
				MyFacture.customForm();
			} else {
				$('#pricesInfos .usingEcoTax').hide();
			}
		});
		
	},
	
	init: function(itemid){
		
		if ($('#statFilter').length > 0){
			catalogueItem.statGraph();
		}
		catalogueItem.preprareDescriptionForm();
		
		MyTabs.initVertical("itemVerticalTab", {
			callback: function (item) {
				MyFacture.post('staff', {action: 'saveTab', linkedtype: 'item', 'linkedid': itemid, openedTab: item.attr('id')});
			}
		});
		
		MyTabs.initHorizontal("catalogueitem");
		
		MyFacture.customForm();
		
		$.each($('.decli_row'), function(k,v){
			var me = $(v);
			
			if (me.find('.qtip-declicontent ').length > 0){
				me.qtip({
					style : {
						classes : 'custom-qtip',
						def		: false
					},
					position: {
						viewport: true
					},
					show : {
						event : 'mouseover'
					},
					hide : {
						event: 'mouseout', 
						fixed: true,
						delay: 100
					},
					content:{
						text: content
					}
				});
			}
			
		});
		
	},
			
	loadStockMoveTab : function(itemid){
		
		if($('#stockmoves_content').html() === ''){
			
			var options = {
				action	: "loadListingTab",
				itemid	: itemid,
				listing	: 'stockmoves'
			};

			MyFacture.post('catalogueitem', options, function (data) {
				
				if (data.listing != undefined){
					$('#stockmoves_content').html(data.listing);
					Listing.init(data.prefix);
					Qtip.init();
					var options = {
						data : {
							action : 'updateListingTab', 
							itemid : itemid,
							listing	: 'stockmoves'
						},
						success: function (data) {
							Listing.refresh(data.listingName, data, data[data.metadatasName]);
							Qtip.init();
						},
						dataType: "json"
					};
					MyForm.prepare(data.listingname + "FilterForm", "catalogueitem", options);
					MyFacture.customForm('#stockmoves_content');
				} else {
					$('#stockmoves_content').html(data.error);
				}
				
			}, 'json');
			
		}
	},		
	
	loadPromotionsTab : function(itemid, declid){
		
		if($('#content_promotions').html() === ''){
			
			var options = {
				action	: "loadListingTab",
				itemid	: itemid,
				declid	: declid,
				listing : 'promotions'
			};

			MyFacture.post('catalogueitem', options, function (data) {
				
				$('#content_promotions').html(data.listing);
				Listing.init(data.prefix);
				Qtip.init();
				
				var options = {
					data : {
						action	: 'updateListingTab',
						itemid	: itemid, 
						listing	: 'promotions'
					},
					success: function (data) {
						Listing.refresh(data.listingName, data, data[data.metadatasName]);
						MyFacture.loadPromoQtip();
					},
					dataType: "json"
				};
				
				MyForm.prepare(data.listingname + "FilterForm", "catalogueitem", options);
				MyFacture.customForm('#content_promotions');
				MyFacture.loadPromoQtip();
			}, 'json');
			
		}
	},
			
	loadStockSerialsTab : function(itemid){

		if($('#stockserials_content').html() === ''){
			
			var options = {
				action	: "loadListingTab",
				itemid	: itemid,
				listing	: 'stockserials',
			};

			MyFacture.post('catalogueitem', options, function (data) {
				$('#stockserials_content').html(data.listing);
				Listing.init(data.prefix);
				
				var options = {
					data : {
						action : 'updateListingTab', 
						itemid : itemid, 
						listing	: 'stockserials'
					},
					success: function (data) {
						Listing.refresh(data.listingName, data, data[data.metadatasName]);
					},
					dataType: "json"
				};
				
				MyForm.prepare(data.listingname + "FilterForm", "catalogueitem", options);
				MyFacture.customForm('#stockserials_content');
			}, 'json');
			
		}
	},		
			
	loadAgendaTab: function(startTime, endTime, days, view){
		setTimeout(function(){
			if($('#item-fullcalendar .fc-content').length == 0){
				MyFacture.customForm();
				Agenda.initCalendar(startTime, endTime, days, view);
			}
		}, 1000);
	},
			
	loadRentListTab: function(itemid){

		$('.subcontent_rent').hide();
		$('.sub_rentlist').show();

		if($('.sub_rentlistContent').html() == ''){
			
			var options = {
				action	: "loadListingTab",
				itemid	: itemid,
				listing	: 'itembooks'
			};

			MyFacture.post('catalogueitem', options, function (data) {
				
				if (data.listing !== undefined){
					
					$('.sub_rentlistContent').html(data.listing);
					Listing.init(data.prefix);
					booksListing.initCalendarListing();
					
					var options = {
						data : {
							action : 'updateListingTab',
							itemid : itemid, 
							listing	: 'itembooks'
						},
						success: function (data) {
							Listing.refresh(data.listingName, data, data[data.metadatasName]);
							booksListing.initCalendarListing();
						},
						dataType: "json"
					};
					MyForm.prepare(data.listingname + "FilterForm", "catalogueitem", options);
					MyFacture.customForm('#rent_content');
				} else {
					$('.sub_rentlistContent').html(data.error);
				}
				
			}, 'json');
			
		}
		
	},		
			
	loadRentSettingsTab: function(){
		$('#content_rent .subcontent_rent').hide();
		$('#content_rent .sub_rentsettings').show();
	},
			
	loadRentSettingsSeasonalTab: function(){
		$('#content_rent .subcontent_rent').hide();
		$('#content_rent .sub_rentsettingsseasonal').show();
	},
			
	loadRentWarehouseTab: function(){
		$('#content_rent .subcontent_rent').hide();
		$('#content_rent .sub_rentwarehouse').show();
	},
			
	// Docs
	loadDocTab: function (doctype, itemid) {
		
		var options = {
			action	: "loadDocTab",
			doctype	: doctype,
			itemid	: itemid
		};

		MyFacture.post('catalogueitem', options, function (data) {
			
			if (data.docsListing !== undefined){
				$('#documents_content').html(data.docsListing);

				Listing.init(data.prefix);
				var options = {
					success: function (data) {
						Listing.refresh(data.listingName, data, data[data.metadatasName]);
					},
					dataType: "json"
				};
				MyForm.prepare(data.listingname + "FilterForm", "catalogueitem&action=updateDocsListing&itemid=" + itemid + '&doctype=' + doctype, options);

				MyFacture.customForm('#documents_content');
			} else {
				$('#documents_content').html(data.error);
			}
		}, 'json');
		
	},		
	
	preprareDescriptionForm: function(){

		var formID = 'fastDescriptionForm';
		
		MyForm.prepare(formID, 'catalogueitem&action=record' + formID, {
			
			success : function(data){
				
				if(MyForm.processJson(data, formID)){
					
					MyWindow.alert(Loc.g('Mise à jour réussie !'), {
						type : 'confirm'
					});
					
				}else{
					
					MyWindow.alert(Loc.g('Echec de mise à jour !'), {
						type : 'error'
					});
					
				}
				
			},
			
			dataType : 'json'
		});
		
		MyFacture.customForm('#' + formID);
		
	},
	
	deleteItem: function(type, id){
		
		var msg =  Loc.g('Supprimer cette entrée du catalogue ?');
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression"),
			buttons		: [
				{
					text : Loc.g("Non"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Oui"), 
					click : function(){
						
						var datas = {
							action	: "delete", 
							type	: type, 
							id		: id
						};
						
						MyFacture.post("catalogueitem", datas, function(data){
							if ($('#itemsListing_container').length > 0){
								Listing.update('itemsListing', false);
							} else if ($('#servicesListing_container').length > 0){
								Listing.update('servicesListing', false);
							}else {								
								Utils.relocate('?_f=catalogue&itmtype='+type);
							}
						}, "json");
						
						$(this).dialog('close');
					}
				}
			]
		};

		MyWindow.alert(msg, options);
		
	},
	
	deleteItemDecli: function(type, id, decliid){
		
		var msg =  Loc.g('Supprimer cette entrée du catalogue ?');
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression"),
			buttons		: [
				{
					text : Loc.g("Non"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Oui"), 
					click : function(){
						var datas = {action:"deleteDecli", type:type, id:id, decliid: decliid};
						MyFacture.post("catalogueitem", datas, function(data){
							if ($('#itemsListing_container').length > 0){
								Listing.update('itemsListing', false);
							} else if ($('#servicesListing_container').length > 0){
								Listing.update('servicesListing', false);
							}else {								
								Utils.relocate('?_f=catalogueitem&id='+id+'&type='+type);
							}
						}, "json");
						$(this).dialog('close');
					}
				}
			]
		};

		MyWindow.alert(msg, options);
		
	},
	
	statGraph: function(){
		
		var object			= Persistent.get("graphics_data",true,true);
		var displayGraphics	= Persistent.get("graphics_data_display",false);
		
		for(var i in object.datas){
			for(var j in object.datas[i].data){
				object.datas[i].data[j] = parseFloat(object.datas[i].data[j], 10);
			}
		}

		var params = {
			chart: {
				renderTo: 'graphics_display',
				height: 220,
				type: 'line',
				backgroundColor : "transparent",
				zoomType : 'x'
			},
			colors:  ['#2372b4','#b2231f','#2fb500','#fe8c05'],
			title: {
				text : Loc.g('Évolution de votre CA'),
				margin:5
			},
			xAxis: {
				title: {
					text: ''
				},
				labels: {
					style: {
						fontSize: '7px'
					},
					step : object.head.length >= 16 ? Math.ceil(object.head.length/16) : 1
				},
				categories: object.head
			},
			yAxis: {
				labels: {
					style: {
						fontSize: '9px'
					}
				},
				title: {
					text: ''
				}
			},
			legend: {
				enabled: true,
				backgroundColor: '#E5E5E5',
				borderColor: '#E5E5E5',
				layout: 'horizontal',
				align: 'center',
				verticalAlign: 'bottom',
				x: 0
			},
			credits: {
				enabled:false
			},
			series:  object.datas ? object.datas : '',
			tooltip: {
				formatter: function() {
					var numformat 	= NumberFormat.loadFromInputs('num_');
					var hasCurrency = this.series.userOptions.hasCurrency;
					var method 		= (hasCurrency == undefined || hasCurrency == 'N') ? 'formatToDisplay' : 'formatToDisplayWithCurrency';

					return ""+ Loc.g("Période")+" : "+this.x +"<br/>"
						+this.series.name + " : "
						+NumberFormat[method](this.y, numformat);
				}
			},
			plotOptions: {
				line: {
					marker: {
						enabled: false,
						states: {
							hover: {
								enabled: true,
								symbol: 'circle',
								radius: 5,
								lineWidth: 1
							}
						}   
					}
				}
			}
		};
		
		catalogueItem.graph = new Highcharts.Chart(params);
		
	},

	editRatesOnChild: function(){
		
		MyWindow.alert(Loc.g('Les catégories tarifaires sont gérées par déclinaisons. Rendez vous sur une déclinaison pour les modifier.'), {type: 'warning'});
		
	},

	editRates :function(type, itemid, declid){
		
		var title = Loc.g('Gestion des tarifs');
		
		var options = {
			title	: title,
			width	: 800,
			buttons	: [
				{
					text : Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer"), 
					click : function(){
						$("#itemRatesForm").submit();
					}
				}
			],
			callback	: function(){catalogueItem.prepareRatesForm();}
		};
		
		MyWindow.load('catalogueitem', {action:'ratesForm', itemid: itemid, declid: declid, type: type}, options);
		
	},

	prepareRatesForm : function(){
		
		var formId = "itemRatesForm";
		
		var options = {
			data	: {
				action : 'itemRatesRecord'
			},
			success	: function(data){
				catalogueItem.recordRatesCallback(data);
			},
			dataType: "json"
		};	
		
		MyForm.prepare(formId, "catalogueitem", options, true);
		MyFacture.customForm();
		
	},
	
	recordRatesCallback : function(data){
		
		var formIsOk = MyForm.processJson(data, "itemRatesForm");
		if(formIsOk){
			MyWindow.close();
			Utils.reload();
        }
		
	},
	
	getMoreBarCodes: function(){

		var currentPage = $('#bcpage').val();
		var itemId = $('#itemid').val();
		
		$.post('./?_f=catalogueitem', {action : 'getMoreBarCodes',  itemId : itemId, page: currentPage}, function(data){
			if (data.success === "Y"){
				$('#catalogueitem #content_barcode table').append(data.barcodes);
				$('#catalogueitem .nomore-barcode').hide();
			} else {
				$('#catalogueitem .more-barcode').hide();
				$('#catalogueitem .nomore-barcode').show();
			}
			Qtip.init();
		});	
		
		$('#bcpage').val(currentPage+1);
		
	},
	
	deleteBar: function(type, id, barid){

		var msg =  Loc.g("Vous êtes sur le point de supprimer le code barre. Êtes vous sur de vouloir continuer ?");
		var options = {
			type		:'warning',
			resizable	: false,
			noclose		: true,
			title		: Loc.g('Suppression de code barre'),
			buttons		: [
					{
						text: Loc.g('Non'),
						click : function(){$(this).dialog("close");}
					},
					{
						text : Loc.g('Oui'),
						click : function(){
							var datas = {action:"deleteItemBar", type:type, id:id, barid:barid};
							MyFacture.post("catalogueitem", datas, function(data){
								if(data.barcoderestant == '0'){
									Utils.reload();
								}
								else{
									$('#bar_'+barid).fadeOut().remove();
								}
							}, "json");	
							$(this).dialog("close");
						}
					}
				]
		};
		MyWindow.alert(msg, options);
		
	},
	
	editBar: function(type, id, barid, declid, from){
		
		var title = Loc.g("Ajout");
		if (barid !== undefined && barid !== 0){
			title = Loc.g('Modification');
		}
		
		var options = {
			title	: title,
			buttons	: [
				{
					text : Loc.g("Annuler"),
					click :  function(){
						$(this).dialog("close")
					}
				},
				{
					text : Loc.g("Enregistrer"),
					click : function(){
						$("#itemBarForm").submit();
					} 
				}
			],
			callback	: function(){
				catalogueItem.prepareeditBarForm();
			}
		};

		MyWindow.load("catalogueitem", {action:"itemBarForm", type:type, id:id, barid:barid, declid:declid, from:from}, options);
		
	},
	
	prepareeditBarForm: function(){
		
		var formId = "itemBarForm";
		var options = {
			data	: {
				action : 'itemBarFormRecord'
			},
			success	: function(data){
				catalogueItem.recordEditBarForm(data);
			}, 
			dataType:"json"
		};
		MyForm.prepare(formId, "catalogueitem", options, true);
		MyFacture.initEvent("#"+formId);
		
		$('#bar_type').change(function(){
			$('#bar_label').val($('#bar_type').find('option:selected').html());
		});
		
	},
	
	recordEditBarForm: function(data) {
		
		var formIsOk = MyForm.processJson(data, "itemBarForm");
		if (formIsOk){
			Utils.reload();
		}
		
	},
	
	editDimension: function(type, id, declid){
		
		var options = {
			title	: Loc.g("Modifier les dimensions"),
			buttons	: [
				{
					text : Loc.g("Annuler"),
					click :  function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer"),
					click : function(){$("#itemDimensionForm").submit();}
				}
			],
			callback	: function(){
				catalogueItem.prepareitemDimensionForm();
			}
		};
		
		MyWindow.load("catalogueitem", {action:"itemDimensionForm", type:type, id:id, declid: declid}, options);
		
	},
	
	prepareitemDimensionForm: function() {
		var formId = "itemDimensionForm";
		var options = {
			data	: {
				action : 'itemDimensionFormRecord'
			},
			success	:function(data){
				Utils.reload();
			}, 
			dataType: "json"
		};
		
		MyForm.prepare(formId, "catalogueitem", options, true);
		MyFacture.initEvent("#"+formId);
	},

	editSpecifications: function(type, id, declid){
		
		var options = {
			title	: Loc.g("Modifier les caractéristiques"),
			width: 800,
			buttons	: [
				{
					text	: Loc.g("Annuler"),
					click	:  function(){
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Enregistrer"),
					click	: function(){
						$("#itemSpecificationsForm").submit();
					}
				}
			],
			callback	: function(){
				catalogueItem.prepareitemSpecificationsForm();
			}
		};
		
		MyWindow.load("catalogueitem", {action:"itemSpecificationsForm", type:type, id:id, declid: declid}, options);
		
	},
	
	prepareitemSpecificationsForm: function(){
		
		var formId	= "itemSpecificationsForm";
		
		var options = {
			data	: {
				action : 'itemSpecificationsFormRecord'
			},
			success	:function(data){
				catalogueItem.recordSpecificationsCallback(data);
			}, 
			dataType	:"json"
		};
		
		MyForm.prepare(formId, "catalogueitem", options, true);
		MyFacture.initEvent("#"+formId);
		
		MyTabs.initHorizontal('itemSpecificationsForm');
		
	},
	
	recordSpecificationsCallback: function(data) {
		
		var formIsOk = MyForm.processJson(data, "itemSpecificationsForm");
		if (formIsOk){
			Utils.reload();
		}
		
	},
			
	cantActiveDecli: function(type, id){
	
		var options = {
			type:  "warning",
			buttons : [
				{
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Créer une copie du produit"), 
					click : function(){
						$(this).dialog("close");
						catalogueItem.edit(type,id,true);
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Vous ne pouvez pas activer la déclinaison sur un produit avec les stocks d'activés ou la location d'activée. Vous pouvez cependant en créer une copie afin de le décliner."), options);
		
	},
	
	activateDeclination: function(type, id){
		
		var options = {
			title	: Loc.g('Activer les déclinaisons'),
			buttons	: [
				{
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer"),
					click : function(){
						$("#activateDeclinationsForm").submit();
					}
				}
			],
			callback : function(){
				catalogueItem.prepareActivateDeclinationForm();
			}
		};
		
		MyWindow.load('catalogueitem', {action:'activateDeclinations', id:id, type:type}, options);
		
	},
	
	prepareActivateDeclinationForm: function(){
		
		var formId = "activateDeclinationsForm";
		var options = {
			success:function(data){
				var formIsOk = MyForm.processJson(data, "activateDeclinationsForm");
				if(formIsOk){
					MyWindow.close();
					Utils.reload();
				} else {
					var msg = "<div class='alert alert-danger' style='margin-top:20px;'>" + data.form.msg + "</div>";
					$('#'+formId).find('.alert-danger').remove();
					$('#'+formId).find('.decl_list_container').after(msg);
				}
			},
			dataType:"json"
		};	
		
		MyForm.prepare(formId, "catalogueitem&action=recordactivateDeclinations", options, true);
		MyFacture.customForm();
		
	},
	
	manageDeclination: function(type, id){
		
		var options = {
			width	: 1200,
			title	: Loc.g('Gérer les déclinaisons'),
			buttons	: [
				{
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer"),
					click : function(){
						$("#manageDeclinationForm").submit();
					}
				}
			],
			callback	: function(){catalogueItem.prepareManageDeclinationForm();}
		};
		
		MyWindow.load('catalogueitem', {action:'manageDeclinations', id:id, type:type}, options);
		
	},
	
	prepareManageDeclinationForm: function(){
		
		var formId = "manageDeclinationForm";
		
		var options = {
			data : {
				action : 'recordmanageDeclinations'
			},
			success	: function(data){
				
				var formIsOk = MyForm.processJson(data, "manageDeclinationForm");
				if(formIsOk){
					MyWindow.close();
					Utils.reload();
				}
			},
			dataType:"json"
		};	
		
		MyForm.prepare(formId, "catalogueitem", options, true);
		MyFacture.customForm();
		
		$('#'+formId+" .addDeclination").click(function(){
			catalogueItem.addDeclination(formId);
		});
		
		$('#'+formId).on('click', '.deleteRow',function(){
			$(this).closest('tr').addClass('hidden').find('.rowstatus').val('deleted');
			$('#'+formId +' .nano').nanoScroller({preventPageScrolling: true});
		});
		
		$('#'+formId +' .nano').nanoScroller({preventPageScrolling: true});
		
	},
	
	addDeclination: function(formId){
		
		var idf1 = {},
			idf2 = {},
			idf3 = {};
		
		var nbDecli				= parseInt($('#'+formId+' #mandecli_decli_nb').val())+1;
		var name				= $('#'+formId+" #mandecli_item_name").val();
		var tradename			= $('#'+formId+" #mandecli_item_tradename").val();
		var tradenametonote		= $('#'+formId+" #mandecli_item_tradenametonote").val();
		var unitamount			= $('#'+formId+" #mandecli_item_unitAmount").val();
		var purchaseAmount		= $('#'+formId+" #mandecli_item_purchaseAmount").val();
		
		idf1.idfid	= $('#idf1_collection').attr('idfid')			=== undefined ? 0 : $('#idf1_collection').attr('idfid');
		idf1.value	= $('#idf1_collection option:selected').val()	=== undefined ? '' : $('#idf1_collection option:selected').val();
		idf1.text	= $('#idf1_collection option:selected').html()	=== undefined ? '' : $('#idf1_collection option:selected').html();
		
		idf2.idfid	= $('#idf2_collection').attr('idfid')			=== undefined ? 0 : $('#idf2_collection').attr('idfid');
		idf2.value	= $('#idf2_collection option:selected').val()	=== undefined ? '' : $('#idf2_collection option:selected').val();
		idf2.text	= $('#idf2_collection option:selected').html()	=== undefined ? '' : $('#idf2_collection option:selected').html(); 

		idf3.idfid	= $('#idf3_collection').attr('idfid')			=== undefined ? 0 : $('#idf3_collection').attr('idfid');
		idf3.value	= $('#idf3_collection option:selected').val()	=== undefined ? '' : $('#idf3_collection option:selected').val();
		idf3.text	= $('#idf3_collection option:selected').html()	=== undefined ? '' : $('#idf3_collection option:selected').html();
		
		
		if (idf1.value === "0" || idf2.value === "0" || idf3.value === "0"){
			$('#'+formId+' .missing_decl_value').show();
			setTimeout(function(){
					$('#'+formId+' .missing_decl_value').fadeOut();		
				}
			,3000 );
			return;
		}
		
		if ($('#'+formId+" tr[declicombinaison='"+idf1.value+"-"+idf2.value+"-"+idf3.value+"']").length > 0){
			
			var me = $('#'+formId+" tr[declicombinaison='"+idf1.value+"-"+idf2.value+"-"+idf3.value+"']");
			
			if (me.hasClass('hidden')){
				me.removeClass('hidden');
				me.find('.rowStatus').val('ok');
			} else {
				$('#'+formId+' .already_decl').show();
				setTimeout(function(){
						$('#'+formId+' .already_decl').fadeOut();		
					}
				,3000 );
			}
			return;
		}
		
		var newRow	= $('#'+formId+" .mainRow").clone();
		
		newRow.removeClass('hidden');
		
		newRow.attr('id', 'mandecli_idecli_row_'+nbDecli);
		
		newRow.find('input.rowindex')
				.val(nbDecli)
				.attr('id', 'mandecli_idecli_rowindex_'+nbDecli)
				.attr('name', "mandecli_decli["+nbDecli+"][rowindex]");
		
		newRow.find('input.rowstatus')
				.val('ok')
				.attr('id', 'mandecli_idecli_rowstatus_'+nbDecli)
				.attr('name', "mandecli_decli["+nbDecli+"][rowstatus]");
		
		newRow.find('input.idf1_syscode')
				.val(idf1.value)
				.attr('id', 'mandecli_idecli_idf1_syscode_'+nbDecli)
				.attr('name', "mandecli_decli["+nbDecli+"][idf1_syscode]");
		
		newRow.find('input.idf2_syscode')
				.val(idf2.value)
				.attr('id', 'mandecli_idecli_idf2_syscode_'+nbDecli)
				.attr('name', "mandecli_decli["+nbDecli+"][idf2_syscode]");
		
		newRow.find('input.idf3_syscode')
				.val(idf3.value)
				.attr('id', 'mandecli_idecli_idf3_syscode_'+nbDecli)
				.attr('name', "mandecli_decli["+nbDecli+"][idf3_syscode]");
		
		newRow.find('.idf1')
				.find('.idfvalue')
				.html(idf1.text);
		
		newRow.find('.idf2')
				.find('.idfvalue')
				.html(idf2.text);
		
		newRow.find('.idf3')
				.find('.idfvalue')
				.html(idf3.text);
		
		newRow.find('.name input')
				.val(name+'-'+nbDecli)
				.attr('id', 'mandecli_idecli_name_'+nbDecli)
				.attr('name',"mandecli_decli["+nbDecli+"][name]");
		 
		newRow.find('.tradename input')
				.val(tradename + ' ' + idf1.text + ' ' + idf2.text + ' ' + idf3.text)
				.attr('id', 'mandecli_idecli_tradename_'+nbDecli)
				.attr('name',"mandecli_decli["+nbDecli+"][tradename]");
		
		newRow.find('.tradenametonote input')
				.val(tradenametonote + ' ' + idf1.text + ' ' + idf2.text + ' ' + idf3.text)
				.attr('id', 'mandecli_idecli_tradenametotnote_'+nbDecli)
				.attr('name',"mandecli_decli["+nbDecli+"][tradenametonote]");
		
		newRow.find('.notesMore textarea')
				.attr('id', 'mandecli_idecli_notesMore_'+nbDecli)
				.attr('name',"mandecli_decli["+nbDecli+"][notesMore]");
								
		newRow.find('.unitAmount input')
				.attr('id', 'mandecli_idecli_priceInc_'+nbDecli)
				.attr('name',"mandecli_decli["+nbDecli+"][priceInc]");
		
		newRow.find('.purchaseAmount input')
				.attr('id', 'mandecli_idecli_purchaseInc_'+nbDecli)
				.attr('name',"mandecli_decli["+nbDecli+"][purchaseInc]");
		
		newRow.attr('declicombinaison', idf1.value + '-' + idf2.value + '-' + idf3.value);
		
		newRow.removeClass('mainRow');
		
		newRow.appendTo($('#'+formId+" .generated_declinations_container table tbody")).show();
		
		$('#'+formId +' .nano').nanoScroller({
			preventPageScrolling	: true,
			scroll					: 'bottom'
		});
		$('#'+formId+' #mandecli_decli_nb').val(nbDecli);
		
		MyFacture.customForm();
		
	},

    updateRateCategories: function(from) {
        // Validator
        var possibleCalls = ['rate', 'amount'];
        if (!possibleCalls.includes(from)) {
            return;
        }

        var numFormat     = NumberFormat.loadFromInputs('unit_numformat_');
        var refPriceF     = NumberFormat.formatToFloat($("#item_unitAmount").val(), numFormat);
        var amountTaxFree = $("#item_unitAmountIsTaxesFree").is(':checked');

        // Catch product tax id
        var tax	= 0;
        if ($("#item_taxid").length > 0){
            tax = $("#item_taxid option:selected").attr('raw_rate');
        }

        $("#itemRates .itm-rate").each(function(index, elem) {
            var rcPrice   = 0;
            var price     = $(this).find('.price');
            var rule      = $(this).find('.rule').val();
            var rcTax     = tax;
            if ($(this).find('.raw_taxrate').val()) {
                rcTax = $(this).find('.raw_taxrate').val();
            } else if ($(this).find('.taxrate').val()) {
                rcTax = $(this).find('.taxrate').val();
            }
            var rcTaxFree = price.hasClass('notTaxesInc');

            switch(rule){
                case "value" :
                    // SPECIAL CASES
                    if (rcTaxFree && from == 'rate') {
                        break;
                    }

                    // ITEM AMOUNT IS TAX FREE
                    if (amountTaxFree) {
                        if (rcTaxFree) {
                            rcPrice = refPriceF;
                        } else {
                            rcPrice = Big(refPriceF).plus(Big(rcTax).div(100).times(Big(refPriceF)));
                            // ex:			100	.plus( (19,6 / 100) * 100 )
                            //			=>	100 + 19,6 => 119,6..
                        }
                    }
                    // ITEM AMOUNT IS TAX INC
                    else {
                        if (rcTaxFree) {
                            rcPrice = Big(refPriceF).div(Big(tax).div(100).plus(1));
                            // ex:			100	.div( (19,6 / 100) + 1 )
                            //			=>	100 / 1,196 => 83,61..
                        } else {
                            rcPrice = refPriceF;
                        }
                    }
                    
                    price.val(NumberFormat.formatToDisplay(rcPrice, numFormat));
                    break;

				case 'percent' :

					var percent			= $(this).find('.percent').val();
					var percentToApply	= Big(1).plus(Big(percent).div(100));

					if (amountTaxFree && !rcTaxFree) {
						rcPrice = Big(refPriceF).plus(Big(rcTax).div(100).times(Big(refPriceF)));
						// ex:			100	.plus( (19,6 / 100) * 100 )
						//			=>	100 + 19,6 => 119,6..
					}
					// ITEM AMOUNT IS TAX INC && RATE CATEGORY IS TAX FREE
					else if (!amountTaxFree && rcTaxFree) {
						rcPrice = Big(refPriceF).div(Big(rcTax).div(100).plus(1));
						// ex:			100	.div( (19,6 / 100) + 1 )
						//			=>	100 / 1,196 => 83,61..
					} else {
						rcPrice = refPriceF;
					}

					rcPrice = Big(rcPrice).times(percentToApply);
					price.val(NumberFormat.formatToDisplay(rcPrice, numFormat));
					break;
			}
		});
	},
	
	adjustFieldset: function() {
		
		var heightProduct	= $("#productInfos").height();
		var heightPrices	= $("#pricesInfos").height();
		heightProduct > heightPrices ? $("#pricesInfos").css("min-height", heightProduct+"px") : $("#productInfos").css("min-height", heightPrices+"px");	
	},
	
	// A factoriser avec l'update
	addException : function(itemid, decliid) {
		
		var options = {
			width	: 520,
			title	: Loc.g('Ajouter une exception tarifaire'),
			buttons	: [
				{
					text : Loc.g("Annuler"), 
					'class' : 'btn btn-default',
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer"),
					'class' : 'btn btn-primary',
					click : function(){
						$("#exceptionPrice").submit();
					}
				}
			],
			callback	: function(){catalogueItem.prepareExceptionPriceForm();}
		};
		
		MyWindow.load('catalogueitem', {action:'exceptionForm', itemid:itemid, decliid:decliid  }, options);
	},
	
	updateException : function(id, itemid, decliid) {
				
		var options = {
			width	: 520,
			title	: Loc.g('Modifier l‘exception tarifaire'),
			buttons	: [
				{
					text	: Loc.g("Annuler"), 
					click	: function(){
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Enregistrer"), 
					click	: function(){
						$("#exceptionPrice").submit();
					}
				}
			],
			callback	: function(){
				catalogueItem.prepareExceptionPriceForm();
			}
		};
		
		MyWindow.load('catalogueitem', {action:'exceptionForm', id:id, itemid:itemid, decliid:decliid }, options);
	},
	
	prepareExceptionPriceForm : function() {
		
		var formId	= "exceptionPrice";
		
		var options = {
			data : {
				action : "recordExceptionForm"
			},
			dataType: "json",
			success : function(data) {

				MyForm.processJson(data, data.form.formId);
				
				if(data.form.status=="ok"){
	
					catalogueItem.displayMoreExceptions(data.itemid, data.decliId, true);
					MyWindow.close();

				}else {
					
					if(data.form.msg != "") {
						$("#errorMsg").html(data.form.msg);
						$("#errorMsg").show();
					}
				}
			}
		}; 
		 
		MyForm.prepare(formId, "catalogueitem", options, true);
		MyFacture.customForm();

	},
	
	addExceptionRow : function() {
		
		$("#excPricePlaceholder").hide();
		
		var indice = $("#indice").val();
		
		if($("#noEntries").length > 0) {
			$("#noEntries").remove();
		}
		var emptyRow = '';
		emptyRow+= '<tr id="rowException_'+indice+'">';
		emptyRow+= '<td><input type="text" id="exception_'+indice+'_third" name="exception['+indice+'][third]" e_autocontactlisting="third" e_autocontactlisting_max="1" e_autocontactlisting_searchonfocus="true" /></td>';
		emptyRow+= '<td><input type="text" name="exception['+indice+'][amount]" id="exception_'+indice+'_amount" value="0" class="exceptionAmount wSmall aright" e_formatnum="true" e_formatprefix="numformat_" /></td>';
		emptyRow+= '<td><a href="javascript:;" onClick="catalogueItem.deleteExceptionRow('+indice+');"><i class="fa fa-trash"></i></a></td>';
		emptyRow+= '</tr>';
		
		$("#exceptionTable tbody").append(emptyRow);
		
		var myscroll = $('#contentScrollExPrice');
        myscroll.scrollTop(myscroll.get(0).scrollHeight);
		
		MyFacture.customForm();
		
		$("#indice").val(parseInt(indice)+1);
	 },
	 
	 deleteExceptionRow : function(id) {

		$("#rowException_"+id).remove();
		
		if($("#exceptionTable tbody tr").length === 1) {
			$("#excPricePlaceholder").show();
		}
	 },
	 
	 deleteException : function(id) {
		
		var options = {
			type	: 'warning',
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Supprimer une exception tarifaire"),
			buttons		: [
				{
					text : Loc.g("Annuler"), 
					'class'	:'btn btn-default',
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Supprimer"), 
					'class'	:'btn btn-primary',
					click : function(){
						
						var data = {
							action	: "deleteExceptionForm",
							id		: id
						};

						MyFacture.post("catalogueitem", data, function(data){
							$("#ite_"+id).remove();
							
							if($("#feedExceptionList ul li").length === 0) {
								$("#excPricePlaceholder").show();
							}
							
						 }, "json");
						 
						 $(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Etes vous sur de vouloir supprimer cette exception tarifaire ?"), options);
	 },
	 
	 displayMoreExceptions : function(itemid, decliid, refresh) {
		
		var refreshList = typeof(refresh) === "undefined" ? false : refresh;
		var currentPage = refreshList ? 0 : parseInt($("#feedExceptionList *[page]:last-child").attr("page"));


		if(refreshList) {
			$("#excPricePlaceholder").hide();
			$("#feedExceptionList").html("");
		}

		var nextPage = currentPage+1;

		var data = {
			action		: "displayMoreException",
			page		: nextPage,
			itemid		: itemid,
			decliid		: decliid
		};

		MyFacture.post("catalogueitem", data, function(data){
			
			if(data.nbExpPrice === 6) {
				$(".exceptionsScroll .moreBtn").show();
			}else {
				$(".exceptionsScroll .moreBtn").hide();
				
				if(data.nbExpPrice === 0) {
					$("#excPricePlaceholder").show();
				}
			}
			
			$("#feedExceptionList").append(data.html);

		}, "json");
	},
	
	searchThirdException : function(itemid, decliid) {
		
		$(".exceptionsScroll .moreBtn").hide();
		
		var third = $("#filter_third").val();
		
		var tmp_third = third.split("_");
		
		var thirdid = tmp_third[1];
		
		var data = {
			action	: "searchException",
			itemid	: itemid,
			decliid	: decliid,
			third	: thirdid
		};

		MyFacture.post("catalogueitem", data, function(data){
			
			$("#feedExceptionList").html(data.html);

		}, "json");
	},
	
	singleUpdateState : function(id, newState) {
		
		var options = {
			type	: "warning",
			title	: newState === "Y" ? Loc.g("Désarchiver") : Loc.g("Archiver"),
			buttons	: [
				{
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Valider"), 
					click : function(){
						MyFacture.post('catalogue&action=updateSingleStateRecord', {item: id, activ: newState}, function(data){
							Utils.reload();
						}, "json");
					}
				}
			]

		};
		MyWindow.alert(Loc.g('Voulez vous') + ' ' + (newState === "Y" ? Loc.g("désarchiver") : Loc.g("archiver")) + ' ' + Loc.g('ce produit ?'), options);
	},
	
	loadProposalTab : function(itemID){
		
		var prefilter = {'itemid' : itemID};
		
		if($('#proposal_content').html() === ''){
			var options = {
				action		: "loadListingTab",
				listing		: 'proposal',
				context		: 'document',
				prefilter	: JSON.stringify(prefilter)	
			};

			MyFacture.post('tabs', options, function (data) {
				
				if (data.listing !== undefined){
					$('#proposal_content').html(data.listing);
					Listing.init(data.prefix);

					var options = {
						data : {
							action		: 'updateListingTab', 
							listing		: 'proposal',
							context		: 'document',
							prefilter	: JSON.stringify(prefilter)
						},
						success: function (data) {
							Listing.refresh(data.listingName, data, data[data.metadatasName]);
						},
						dataType: "json"
					};
					MyForm.prepare(data.listingname + "FilterForm", "tabs", options);
					MyFacture.customForm('#proposal_content');
				} else {
					$('#proposal_content').html(data.error);
				}
				
			}, 'json');
		}
	}
	 
};


window.DeclinationsFieldsListing = {
	
	prepareFilterForm: function(){
        var options = {
			data		: {
				action : 'updateListing'
			},
			success		: function(data){
				DeclinationsFieldsListing.processFilterForm(data);
			}, 
			dataType	:"json"
		};
        MyForm.prepare("itemsdeclinationsfieldsFilterForm", "declinationsfields", options);
	},
	
	processFilterForm: function(data){
		Listing.refresh("itemsdeclinationsfieldsListing", data, data.itemsdeclinationsfields_metadatas);		
		$('.statBlock:visible').nanoScroller({preventPageScrolling: true});
	}
	
};

window.DeclinationsFields = {

	cantDelete: function(){
	
		var options = {
			type:  "warning"
		};
		
		MyWindow.alert(Loc.g("Vous ne pouvez pas supprimer cette déclinaison car elle est utilisée dans vos produits"), options);
		
	},

	deleteField : function(id){
	
		var options = {
			type: 'warning',
			buttons	: [
				{
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog('close');
					}
				},
				{
					text : Loc.g("Valider"), 
					click : function(){
						
						MyFacture.post(
							"declinationsfields", 
							{
								action	: "deleteDeclinationField", 
								id		: id
							}, 
							function(data){
								MyWindow.alert(Loc.g('La déclinaison a été supprimée'), {type:'confirm'});
								Listing.update('itemsdeclinationsfieldsListing',true);
							}, 
							"json"
						);	
					}
				}
			]
		};
	
		MyWindow.alert(Loc.g('Valider la suppression de la déclinaison'), options);
		
	},

	createForm: function(id){
		
		var params = {action:'fieldsForm'};
		
		if (id !== undefined){
			params.id = id;
		}
		
		var title = Loc.g('Ajouter une déclinaison');
		
		var options = {
			title	: title,
			width	: 600,
			buttons	: [
				{
					text : Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer"),
					click : function(){
						$("#itemsDeclinationsFieldsForm").submit();
					}
				}
			],
			callback	: function(){
				DeclinationsFields.prepareCreateForm();
			}
		};
		
		MyWindow.load('declinationsfields', params, options);
		
	},
	
	prepareCreateForm : function(){
		
		var formId = "itemsDeclinationsFieldsForm";
		var options = {
			success:function(data){DeclinationsFields.recordCallback(data);},
			dataType:"json"
		};	
		MyForm.prepare(formId, "declinationsfields&action=recordFields", options, true);
		MyFacture.customForm();
		
		$('#sortable_idf').sortable({
			containment : 'parent'
		});
		
	},
	
	recordCallback: function(data){
	
		var formIsOk = MyForm.processJson(data, "itemsDeclinationsFieldsForm");
		if(formIsOk){
			MyWindow.close();
			$('#itemsDeclinationsFieldsForm').find('.formAlert').hide();
			if ($('#itemsdeclinationsfieldsListing').length > 0){
				Listing.update('itemsdeclinationsfieldsListing',true);
			} else {
				Utils.reload();
			}
        } else {
			if (data.form.msg != ""){
				$('#itemsDeclinationsFieldsForm').find('.formAlert').html(data.form.msg).show();
			} else {
				$('#itemsDeclinationsFieldsForm').find('.formAlert').hide();
			}
		}
		
	},
	
	removeIdf: function(me){
		
		me.closest('li').remove();
		if ($('#itemsDeclinationsFieldsForm .fields_collections #sortable_idf li').length === 2){
			$('#itemsDeclinationsFieldsForm .fields_collections .placeholderLi').show();
		}
		
	},
	
	addFieldsToCollection: function() {
		
		var indexes = parseInt($('#itemsDeclinationsFieldsForm .fields_collections #fields_indexes').val()) + 1 ;
		$('#itemsDeclinationsFieldsForm .fields_collections #fields_indexes').val(indexes);
		
		var newLine = $('#itemsDeclinationsFieldsForm .fields_collections #sortable_idf #defautIdf').clone();
		newLine.removeAttr('id').removeClass('hidden');
		
		newLine.find('.tmpIndex').attr('id','idf_fields_index_'+indexes).attr('name', 'idf_fields['+indexes+'][index]').val(indexes);
		newLine.find('.tmpCode').attr('id', 'idf_fields_syscode_'+indexes).attr('name', 'idf_fields['+indexes+'][syscode]');
		newLine.find('.tmpValue').attr('id', 'idf_fields_name_'+indexes).attr('name', 'idf_fields['+indexes+'][name]');
		
		$('#itemsDeclinationsFieldsForm .fields_collections .placeholderLi').hide();
		$('#itemsDeclinationsFieldsForm .fields_collections #sortable_idf').append(newLine);
		
		$( "#sortable_idf" ).sortable("refresh");
		
	}
	
};

window.associatedItem = {
	
	addForItem: function(currentItemId, itemToAssociate){
		
		var itemToAssociateSplitedId = itemToAssociate.id.split('_');
		var itemToAssociateId = itemToAssociateSplitedId[1] + "_" + itemToAssociateSplitedId[2];
		
		var datas = {
			action			: "associatedItem", 
			currentItemId	: currentItemId, 
			itemToAssociateId	: itemToAssociateId
		};
		
		MyFacture.post("catalogueitem", datas, function(data){
			
			if (data.success == "Y"){
				$('#itemAssociatedList').append(data.itemAssociatedHTML);
				$('#itemAssociatedList .placeholder').hide();
			} else {
				MyWindow.alert(data.msg, {type:'error'})
			}
			
			$('#associatedItemAdd').tokenInput('clear')
		}, "json");
		
	},
			
	deleteAssociation: function(associationId){
		
		var options = {

				type	: 'warning',
				buttons : [
					{
						text : Loc.g("Annuler"), 
						'class' : 'btn btn-default',
						click : function(){
							$(this).dialog("close");
						}
					},
					{
						text : Loc.g("Délier"), 
						'class' : 'btn btn-primary',
						click : function(){
							associatedItem.do_deleteAssociation(associationId);
						}
					}
				]
			};
			
			MyWindow.alert(Loc.g('Délier les produits ?'), options);

	},
	
	duplicateAssociationDecli: function(associationId){
		
		var options = {

				type	: 'warning',
				buttons : [
					{
						text : Loc.g("Annuler"), 
						click : function(){
							$(this).dialog("close");
						}
					},
					{
						text : Loc.g("Associer"), 
						click : function(){
							associatedItem.do_duplicateAssociationDecli(associationId);
						}
					}
				]
			};
			
			MyWindow.alert(Loc.g('Appliquer aux déclinaisons ?'), options);

	},
	
	do_duplicateAssociationDecli: function(associationId){
		
		
		MyWindow.wait("alertWindow");
		
		MyFacture.post(
			"catalogueitem", 
			{
				action			: "duplicateAssociationDecli", 
				associationId	: associationId
			},
			function(data){
				MyWindow.awake("alertWindow");
				if (data.success === 'Y'){
					MyWindow.alert(Loc.g('Le produit a bien été associé aux déclinaisons'), {type:'confirm'});
				} else {
					MyWindow.alert(data.msg, {type:'error',width : 400});
				}

			}, 
			"json"
		);
		
	},
	
	
	do_deleteAssociation: function(associationId){

		MyFacture.post(
			"catalogueitem", 
			{
				action			: "deleteAssociation", 
				associationId	: associationId
			}, 
			function(data){
				if (data.success === 'Y'){
					$("div[associationid="+data.associationid+"]").fadeOut().remove();
					MyWindow.alert(Loc.g('Les produits ont bien étés déliés'), {type:'confirm'});

					if ($("#itemAssociatedList .itemAssociated").length === 0){
						$('#itemAssociatedList .placeholder').show();
					}

				} else {
					MyWindow.alert(Loc.g('Les produits n’ont pas pu être déliés'), {type:'error'});
				}
			}, 
			"json"
		);
	}
};

window.Items = {
	
	prepareStockFilters : function(){
		
		var $stockEnabled = $('#itemsListing_filter_stockEnabled');
		
		if($stockEnabled.val() == 'N'){
			$('.stockEnabled').hide();
		}else{
			$('.stockEnabled').show();
		}
		
	},
	
	prepareFilterForm: function(){
		
		this.prepareStockFilters();
		
		var options = {success:function(data){Items.processFilterForm(data);}, dataType:"json"};
		MyForm.prepare("itemsFilterForm", "catalogue", options);
		
		// i let this here in case of someone do the price range filter
		//this.initRangePriceForm();
	},
	processFilterForm: function(data){
		$("#itemsListing_loading").fadeIn();
		Listing.refresh("itemsListing", data, data.items_metadatas);
	},
		
	initRangePriceForm : function(){
				
		var currentCurrencySymbol = $('#itemsListing_filter_range_rc').find(":selected").data('currency');
		
		var amountMin = $('#itemsListing_filter_range_minPrice').val() !== "" ? parseFloat($('#itemsListing_filter_range_minPrice').val(), 10) : 0;
		var amountMax = $('#itemsListing_filter_range_maxPrice').val() !== "" ? parseFloat($('#itemsListing_filter_range_maxPrice').val(), 10) : 1000000;
		
		$("#slider-rangePrice").slider({
			range: true,
			min: 0,
			max: 1000,
			values: [amountMin, amountMax],
			
			slide: function( event, ui ) {
				var currentCurrencySymbol = $('#itemsListing_filter_range_rc').find(":selected").data('currency');
				$("#rangePrice").val(ui.values[0]+ " " + currentCurrencySymbol + " " + Loc.g('et') + " " + ui.values[1] + " " + currentCurrencySymbol);
			},

			stop: _.debounce(function( event, ui ) {
				$('#itemsListing_filter_range_minPrice').val(ui.values[0]);
				$('#itemsListing_filter_range_maxPrice').val(ui.values[1]);
				Listing.update('itemsListing');
			}, 1000)
		});
		
		// get number format
		var numformat = {'name':"", 'currency':"", 'decimals':"", 'thousands':"", 'currencypos':"", 'position':""};
		numformat = Persistent.get("numformat", true, true);
		
		// set txt
		$("#rangePrice").val(NumberFormat.formatToDisplay($("#slider-rangePrice").slider("values", 0), numformat) + " " + currentCurrencySymbol + " " + Loc.g('et')+" "+NumberFormat.formatToDisplay($("#slider-rangePrice").slider("values", 1), numformat) + " " + currentCurrencySymbol);
		
	},
	

};
